"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var constants_1 = require("../constants");
function useSearchBarEvents(trackEvent) {
    return (0, react_1.useMemo)(function () { return ({
        noResults: function (textEntered) {
            trackEvent(constants_1.SearchBarEvents.NoResults, { textEntered: textEntered });
        },
        typedButDidNotSubmit: function () {
            trackEvent(constants_1.SearchBarEvents.TypedNoSubmit);
        },
        focused: function () {
            trackEvent(constants_1.SearchBarEvents.Focused);
        },
        removeRecentSearch: function () {
            trackEvent(constants_1.SearchBarEvents.RemovedRecentSearch, {
                removedType: 'Single'
            });
        },
        suggestionClicked: function (eventData) {
            trackEvent(constants_1.SearchBarEvents.SuggestionClicked, eventData);
        },
        goClicked: function (eventData) {
            trackEvent(constants_1.SearchBarEvents.GoClicked, eventData);
        },
        pressedEnter: function (eventData) {
            trackEvent(constants_1.SearchBarEvents.PressedEnter, eventData);
        }
    }); }, [trackEvent]);
}
exports.default = useSearchBarEvents;
//# sourceMappingURL=useSearchBarEvents.js.map